import { render, staticRenderFns } from "./Kundalik.vue?vue&type=template&id=334dde14"
import script from "./Kundalik.vue?vue&type=script&lang=js"
export * from "./Kundalik.vue?vue&type=script&lang=js"
import style0 from "./Kundalik.vue?vue&type=style&index=0&id=334dde14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports